"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconCheck from "@/app/(components)/generics/Icons/IconCheck";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { FounderOffer } from "@/app/vars/Credits";
import { Globals } from "@/app/vars/Globals";
import styles from "./BlogCta.module.css";

type Props = DefaultProps & {
  title: string;
  text: string;
  btn: string;
};

export default function BlogCta(props: Props) {
  const T = useT();
  const { title, text, btn, params } = props;
  const isWaitlist = Globals.WAITLIST_ENABLED;

  const open = () => {
    if (isWaitlist) {
      ModalStore.getState().openWaitlist(params);
      return;
    }
    ModalStore.getState().openDemo();
  };

  return (
    <div className={styles.container}>
      <div className={styles.texts}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.text}>{isWaitlist ? T(TKey.HOME_WAITLIST_FINAL_TEXT) : text}</p>
      </div>

      <div className={styles.action}>
        <Button
          min={false}
          params={params}
          text={isWaitlist ? T(TKey.HOME_WAITLIST_CTA) : btn}
          isLink={false}
          type={ButtonType.PRIMARY}
          onClick={open}
        />
        {isWaitlist && (
          <p className={styles.note}>
            <IconCheck color="var(--color-green-3)" />
            {T(TKey.HOME_WAITLIST_HERO_NOTE).replace(
              "{{discount}}",
              String(FounderOffer.DISCOUNT_PERCENT),
            )}
          </p>
        )}
      </div>
    </div>
  );
}
